<template>
  <div>
    <slot name="button">
      <b-dropdown-item @click="handleClick">Rechazar pallets</b-dropdown-item>
    </slot>
    <b-modal id="rechazar-pallets" size="lg" title="Rechazar pallets" @show="onShow" @ok="handleOk">
      <h1>Identificacion de la muestra</h1>
      <b-form>
        <b-form-group label="Pallets:" label-cols="auto">
          <b-form-input disabled v-model="form.pallets"></b-form-input>
        </b-form-group>
        <!-- Guia, variedad, pallets, productor, bandeja, kilogramos, embalaje -->
        <b-form-group label="Guia:" label-cols="auto">
          <b-form-input v-model="form.waybills"></b-form-input>
        </b-form-group>
        <b-form-group label="Variedad:" label-cols="auto">
          <b-form-input v-model="form.varieties"></b-form-input>
        </b-form-group>
        <b-form-group label="Productor:" label-cols="auto">
          <b-form-input v-model="form.grower"></b-form-input>
        </b-form-group>
        <b-form-group label="Bandejas:" label-cols="auto">
          <b-form-input v-model="form.quantity"></b-form-input>
        </b-form-group>
        <b-form-group label="Kilogramos:" label-cols="auto">
          <b-form-input v-model="form.kilograms"></b-form-input>
        </b-form-group>
        <b-form-group label="Embalaje:" label-cols="auto">
          <b-form-input v-model="form.container"></b-form-input>
        </b-form-group>
        <h1>Daños y defectos (%)</h1>
        <!-- 
        INACEPTABLES
        Colapsados
        Hongos
        Insectos
        Tierra
        MAYORES
        Blandos
        Semi Blandos
        Exudación de Jugo
        Verdes
        Roiizos
        Déficit Bloom
        Machucones con Jugo
        Deshidratados
        MENORES
        Pedicelo
        Restos de Flor
        Machucones Secos
        Cicatrices/Heridas 
        -->
        <h2>Inaceptables</h2>
        <b-input-group prepend="Colapsados (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.colapsados" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('colapsados') ? 'text-danger' : ''"
            v-model="form.defects.colapsados"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Hongos (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.hongos" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('hongos') ? 'text-danger' : ''"
            v-model="form.defects.hongos"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Insectos (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.insectos" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('insectos') ? 'text-danger' : ''"
            v-model="form.defects.insectos"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Tierra (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.tierra" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('tierra') ? 'text-danger' : ''"
            v-model="form.defects.tierra"
          ></b-form-input>
        </b-input-group>
        <h2>Mayores</h2>
        <b-input-group prepend="Blandos (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.blandos" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('blandos') ? 'text-danger' : ''"
            v-model="form.defects.blandos"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Semi Blandos (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.semiBlandos" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('semiBlandos') ? 'text-danger' : ''"
            v-model="form.defects.semiBlandos"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Exudación de Jugo (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.exudacionJugo" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('exudacionJugo') ? 'text-danger' : ''"
            v-model="form.defects.exudacionJugo"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Verdes (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.verdes" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('verdes') ? 'text-danger' : ''"
            v-model="form.defects.verdes"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Rojizos (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.rojizos" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('rojizos') ? 'text-danger' : ''"
            v-model="form.defects.rojizos"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Déficit Bloom (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.deficitBloom" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('deficitBloom') ? 'text-danger' : ''"
            v-model="form.defects.deficitBloom"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Machucones con Jugo (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.machuconesJugo" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('machuconesJugo') ? 'text-danger' : ''"
            v-model="form.defects.machuconesJugo"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Deshidratados (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.deshidratados" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('deshidratados') ? 'text-danger' : ''"
            v-model="form.defects.deshidratados"
          ></b-form-input>
        </b-input-group>
        <h2>Menores</h2>
        <b-input-group prepend="Pedicelo (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.pedicelo" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('pedicelo') ? 'text-danger' : ''"
            v-model="form.defects.pedicelo"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Restos de Flor (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.restosFlor" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('restosFlor') ? 'text-danger' : ''"
            v-model="form.defects.restosFlor"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Machucones secos (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.machuconesSecos" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('machuconesSecos') ? 'text-danger' : ''"
            v-model="form.defects.machuconesSecos"
          ></b-form-input>
        </b-input-group>
        <b-input-group prepend="Cicatrices heridas (%)" class="mb-1">
          <b-form-input disabled v-model="defectsTolerances.cicatricesHeridas" type="number"></b-form-input>
          <b-form-input
            type="number"
            :class="noCumple('cicatricesHeridas') ? 'text-danger' : ''"
            v-model="form.defects.cicatricesHeridas"
          ></b-form-input>
        </b-input-group>
        <!-- Observaciones -->
        <h1>Conclusiones</h1>
        <b-form-group label="Observaciones">
          <b-form-textarea v-model="form.observations"></b-form-textarea>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "RechazarPallets",
  methods: {
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      const payload = this.form;
      try {
        await this.$axios.post("/api/v1/bluefields/rechazo/rechazar_pallets/", payload);
        this.$bvModal.hide("rechazar-pallets");
        this.$bvToast.toast("Pallets rechazados", {
          title: "Éxito",
          variant: "success",
          solid: true
        });
        this.$emit("on-action-success");
      } catch (error) {
        this.$bvToast.toast("Error al rechazar pallets", {
          title: "Error",
          variant: "danger",
          solid: true
        });
      }
    },
    handleClick() {
      this.$bvModal.show("rechazar-pallets");
    },
    noCumple(defecto) {
      return this.form.defects[defecto] > this.defectsTolerances[defecto];
    },
    onShow() {
      this.resetForm();
      this.form.pallets = this.pallets;
      this.form.waybills = this.waybills;
      this.form.varieties = this.varieties;
      this.form.grower = this.growers;
      this.form.quantity = this.quantity;
      this.form.kilograms = this.kilograms;
      this.form.container = this.containers;
      this.form.observations =
        "El producto presentaba problemas de frutos con xx x%; esto asociado a presencia de frutos xx x%;, y xx x% hacen que la fruta no presente condición necesaria para su exportación.";
    },
    resetForm() {
      this.form.pallets = "";
      this.form.waybills = "";
      this.form.varieties = "";
      this.form.grower = "";
      this.form.quantity = "";
      this.form.kilograms = "";
      this.form.container = "";
      this.form.observations = "";
      this.form.defects = {
        colapsados: 0,
        hongos: 0,
        insectos: 0,
        tierra: 0,
        blandos: 0,
        semiBlandos: 0,
        exudacionJugo: 0,
        verdes: 0,
        rojizos: 0,
        deficitBloom: 0,
        machuconesJugo: 0,
        deshidratados: 0,
        pedicelo: 0,
        restosFlor: 0,
        machuconesSecos: 0,
        cicatricesHeridas: 0
      };
    }
  },
  data() {
    return {
      defectsTolerances: {
        colapsados: 0,
        hongos: 0,
        insectos: 0,
        tierra: 0,
        blandos: 3,
        semiBlandos: 8,
        exudacionJugo: 1,
        verdes: 2,
        rojizos: 6,
        deficitBloom: 8,
        machuconesJugo: 1,
        deshidratados: 4,
        pedicelo: 8,
        restosFlor: 8,
        machuconesSecos: 3,
        cicatricesHeridas: 8
      },
      form: {
        pallets: "",
        waybills: "",
        varieties: "",
        grower: "",
        quantity: "",
        kilograms: "",
        container: "",
        observations: "",
        defects: {
          colapsados: 0,
          hongos: 0,
          insectos: 0,
          tierra: 0,
          blandos: 0,
          semiBlandos: 0,
          exudacionJugo: 0,
          verdes: 0,
          rojizos: 0,
          deficitBloom: 0,
          machuconesJugo: 0,
          deshidratados: 0,
          pedicelo: 0,
          restosFlor: 0,
          machuconesSecos: 0,
          cicatricesHeridas: 0
        }
      }
    };
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    pallets() {
      const pallets = this.items.map((item) => item.pallet_number);
      let uniqueChars = [...new Set(pallets)];
      return uniqueChars.join("-");
    },
    waybills() {
      const waybills = this.items.map((item) => item.waybill_number);
      let uniqueChars = [...new Set(waybills)];
      return uniqueChars.join(", ");
    },
    varieties() {
      const varieties = this.items.map((item) => item.variety_name);
      let uniqueChars = [...new Set(varieties)];
      return uniqueChars.join(", ");
    },
    growers() {
      const grower = this.items.map((item) => item.origin_name);
      let uniqueChars = [...new Set(grower)];
      return uniqueChars.join(", ");
    },
    containers() {
      const containers = this.items.map((item) => item.container_name);
      let uniqueChars = [...new Set(containers)];
      return uniqueChars.join(", ");
    },
    quantity() {
      const quantity = this.items.reduce((acc, item) => {
        return acc + item.quantity;
      }, 0);
      return quantity;
    },
    kilograms() {
      const kilograms = this.items.reduce((acc, item) => {
        return acc + parseFloat(item.net_kilograms);
      }, 0);
      return kilograms.toFixed(2);
    }
  }
};
</script>

<style>
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  color: #b6e5e9 !important;
  background-color: #2f353a !important;
}
</style>
